import React, { useState, useEffect } from "react";

const PageDataContext = React.createContext({
  meta: {},
  pageData: {},
});

export default PageDataContext;

export const PageDataProvider = ({ pageData, children, meta }) => {
  const [breakpoint, setBreakpoint] = useState();
  const [hydratedMeta, setHydratedMeta] = useState(meta);

  // TODO: match it with the grid definition from UI
  function getBreakpoint() {
    if (window.matchMedia("(max-width: 1023px)").matches) {
      return "small";
    } else if (
      window.matchMedia("(min-width: 1024px) and (max-width: 1279px)").matches
    ) {
      return "medium";
    } else if (
      window.matchMedia("(min-width: 1280px) and (max-width: 1440px)").matches
    ) {
      return "large";
    } else {
      return "xlarge";
    }
  }

  useEffect(() => {
    function handleResize() {
      const bp = getBreakpoint();
      setBreakpoint(bp);
      setHydratedMeta({
        ...meta,
        isDesktop: bp != "small",
        isMobile: bp === "small",
      });
    }
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <PageDataContext.Provider
      value={{
        pageData: pageData,
        meta: hydratedMeta,
        breakpoint: breakpoint,
      }}
    >
      {children}
    </PageDataContext.Provider>
  );
};
